export default __webpack_public_path__ + "static/media/calificacion-umbral.99ee5818.png";